import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuStateService {
  private menuVisibleSubject = new BehaviorSubject<boolean>(false);
  menuVisible$ = this.menuVisibleSubject.asObservable();

  showMenu() {
    if (!this.menuVisibleSubject.value) {
      this.menuVisibleSubject.next(true);
    }
  }

  hideMenu() {
    if (this.menuVisibleSubject.value) {
      this.menuVisibleSubject.next(false);
    }
  }

  toggleMenu() {
    this.menuVisibleSubject.next(!this.menuVisibleSubject.value);
  }

  isMenuVisible(): boolean {
    return this.menuVisibleSubject.value;
  }
}
